module.exports = __webpack_public_path__ + "img/D3M10.79114fea.jpg";